import { Optional } from '../../../Common/interfaces';
import { ExerciseDto } from '../interfaces';

export function addPageNumber(
    exercise: Optional<ExerciseDto>,
    pageNumber: Optional<string | number>,
): Optional<ExerciseDto> {
    if (exercise == null) {
        return null;
    }

    if (pageNumber == null || Number.isNaN(+pageNumber)) {
        return exercise;
    }

    return { ...exercise, CurrentPage: +pageNumber };
}
